"use client";

import Image from "next/image";
import { motion, useScroll, useTransform } from "framer-motion";
import AboutHero from "./AboutHero";
import AboutContent from "./AboutContent";

const sectionVariants = {
  hidden: { opacity: 0, y: 48 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] as [number, number, number, number] },
  },
};

export default function AboutClient() {
  const { scrollYProgress } = useScroll();
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  return (
    <div className="relative min-h-screen">
      {/* ── Fixed Parallax Aesthetic Background ── */}
      <div className="pointer-events-none fixed inset-0 -z-10 h-[120vh] w-full overflow-hidden bg-[var(--background)]">
        <motion.div style={{ y: backgroundY }} className="absolute inset-0 h-full w-full">
          <Image
            src="https://images.unsplash.com/photo-1705928418747-875e2e64a969?q=80&w=1974&auto=format&fit=crop"
            alt="Abstract Dark Aesthetic"
            fill
            sizes="100vw"
            className="object-cover opacity-30 md:opacity-40"
            priority
          />
        </motion.div>
        {/* Soft blackout gradients to blend smoothly with [var(--background)] */}
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--background)] via-[var(--background)]/70 to-[var(--background)]" />
      </div>

      <div className="relative z-10">
        <motion.div variants={sectionVariants} initial="hidden" animate="show">
          <AboutHero />
        </motion.div>
        <AboutContent />
      </div>
    </div>
  );
}
